import { render, staticRenderFns } from "./Issue.vue?vue&type=template&id=4537b37a"
import script from "./Issue.vue?vue&type=script&lang=js"
export * from "./Issue.vue?vue&type=script&lang=js"
import style0 from "./Issue.vue?vue&type=style&index=0&id=4537b37a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports